import React, { useEffect, useState } from 'react'
import TutorSidebar from '../../TutorSidebar/TutorSidebar'
import TutorFooter from '../../TutorFooter/TutorFooter'
import { Link } from 'react-router-dom'
import TutorHeader from '../../TutorHeader/TutorHeader'
import { useDispatch, useSelector } from 'react-redux'
import { getTutorMyCourseGroupListData } from '../../../../Redux/action/TutorAction'
import ResponsivePagination from '../../../../Common/Pagination'
import Beatloader from '../../../../Common/BeatLoader'
const TutorCourseList = () => {

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getTutorMyCourseGroupListData())

    }, []);

    const {
        loadingTutorMyCourseGroupListApi,
        TutorMyCourseGroupListApiData,
        TutorMyCourseGroupListApiError
    } = useSelector(state => state?.TutorReducer);

    //pagination
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1); // ✅ 1-based page index
    const dataPerPage = 10;

    useEffect(() => {
        if (!TutorMyCourseGroupListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(TutorMyCourseGroupListApiData.slice(start, end));
        setPageCount(Math.ceil(TutorMyCourseGroupListApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, TutorMyCourseGroupListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };

    return (
        <div className='pagination-component'>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Group Course List
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="course-list-sec">
                                    {loadingTutorMyCourseGroupListApi ?
                                        <Beatloader />
                                        :

                                        <div className="row">
                                            {TutorMyCourseGroupListApiData?.length > 0 ?
                                                currentData?.map((data) => (
                                                    <div className="col-lg-6 col-md-6 mb-4">
                                                        <div className="card">
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-lg-9 col-md-9">
                                                                        <h6>Course: {data?.name}</h6>
                                                                        <h6 style={{ fontSize: 14 }} className='line-clamp'>
                                                                            Description:
                                                                            <span>


                                                                                {data?.description}
                                                                            </span>
                                                                        </h6>
                                                                    </div>
                                                                    <div className="col-lg-3 col-md-3 d-flex justify-content-end">
                                                                        <p style={{ fontSize: 13 }}>
                                                                            <i>{data?.approval_status}</i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-lg-12">
                                                                        <div className="row mt-4">
                                                                            <div className="col-lg-6 col-md-6 mb-3">
                                                                                <Link to={`/tutor/group-course-batch-list/${btoa(data?.id)}`}>
                                                                                    <button className="btn view-btn w-100">
                                                                                        View Details
                                                                                    </button>
                                                                                </Link>
                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6 mb-3">
                                                                                <Link to={`/tutor/create-new-batch/${btoa(data?.id)}`}>
                                                                                    <button className="btn add-btn w-100">Add New Batch</button>
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                                :
                                                <div className='no-data-img'>
                                                    <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                </div>}

                                            {pageCount > 1 && (
                                                <ResponsivePagination
                                                    pageCount={pageCount}
                                                    currentPage={currentPage}
                                                    handlePageClick={handlePageClick}
                                                />
                                            )}
                                        </div>
                                    }
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorCourseList